import { z } from 'zod/v3';

export const MfaStatusSchema = z.enum(['yes', 'no', 'partial', 'unknown']);
export type MfaStatus = z.infer<typeof MfaStatusSchema>;

export const SsoStatusSchema = z.enum(['yes', 'no', 'unknown']);
export type SsoStatus = z.infer<typeof SsoStatusSchema>;

export const AccessReviewCadenceSchema = z.enum([
  'monthly',
  'quarterly',
  'annual',
  'none',
  'unknown',
]);
export type AccessReviewCadence = z.infer<typeof AccessReviewCadenceSchema>;

export const ToolSecurityEntrySchema = z.object({
  mfaEnforced: MfaStatusSchema,
  ssoConnected: SsoStatusSchema,
  ssoProvider: z.string().optional(),
  accessReviewCadence: AccessReviewCadenceSchema,
  adminCount: z.number().int().nonnegative(),
});
export type ToolSecurityEntry = z.infer<typeof ToolSecurityEntrySchema>;

export const ToolSecurityMatrixSchema = z.record(
  z.string(),
  ToolSecurityEntrySchema,
);
export type ToolSecurityMatrix = z.infer<typeof ToolSecurityMatrixSchema>;

export const MFA_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'partial', label: 'Partial' },
  { value: 'no', label: 'No' },
  { value: 'unknown', label: 'Not sure' },
] as const satisfies readonly { value: MfaStatus; label: string }[];

export const SSO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unknown', label: 'Not sure' },
] as const satisfies readonly { value: SsoStatus; label: string }[];

export const CADENCE_OPTIONS = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'annual', label: 'Annual' },
  { value: 'none', label: 'None' },
  { value: 'unknown', label: 'Not sure' },
] as const satisfies readonly { value: AccessReviewCadence; label: string }[];
